import { gql } from "@apollo/client";
import DefinitionTable from "controls/DefinitionTable";
import { DialogToolbarButton } from "controls/DialogsToolbar";
import Message from "controls/Message";
import Toolbar, { ToolbarButton } from "controls/Toolbar";
import oauthAuthorise from "helpers/oauthAuthorise";
import useData from "hooks/useData";
import { Link, LinkOff } from "mdi-material-ui";
import React from "react";
import makeConfirmActionDialog from "readmin_pages/shared/makeConfirmActionDialog";
import { ReadminObjectsTableFragment } from "readmin_pages/shared/ReadminObjectsTable";

export default function LiveStreamFbAuthStatus() {
  const [data, dataMeta] = useData(gql`
    query LiveStreamFbAuthStatus {
      currentUser {
        id
        orgAdmins {
          id
          ...ReadminObjectsTableFragment
        }
        venueAdmins {
          id
          ...ReadminObjectsTableFragment
        }
        liveStreamFbAuth {
          id
          name
          email
        }
      }
    }
    ${ReadminObjectsTableFragment}
  `);

  return (
    <>
      {data?.currentUser && !data?.currentUser?.liveStreamFbAuth && (
        <Message content="You have not connected Facebook account for live streaming." />
      )}
      {data?.currentUser?.liveStreamFbAuth && (
        <DefinitionTable
          style={{ margin: "0 -10px" }}
          rows={[
            ["Name", data.currentUser.liveStreamFbAuth.name],
            ["Email", data.currentUser.liveStreamFbAuth.email],
          ]}
        />
      )}
      <Toolbar>
        <ToolbarButton
          icon={<Link />}
          content={data?.currentUser?.liveStreamFbAuth ? "Re-connect Facebook Account" : "Connect Facebook Account"}
          onClick={() => oauthAuthorise("facebook_live_stream_auth")}
        />
        <DialogToolbarButton dialog={<RemoveLiveStreamFbAuthDialog />} onSubmit={() => dataMeta.refetch()} />
      </Toolbar>
    </>
  );
}

export const RemoveLiveStreamFbAuthDialog = makeConfirmActionDialog({
  mutationName: "currentUserRemoveLiveStreamFbAuth",
  action: "Disconnect Facebook Account",
  useButtonProps: () => {
    const [data] = useData(gql`
      query CurrentUserRemoveLiveStreamFbAuthDialog {
        currentUser {
          liveStreamFbAuth {
            id
          }
        }
      }
    `);

    return {
      content: "Disconnect Facebook Account",
      hidden: !data?.currentUser?.liveStreamFbAuth,
      icon: <LinkOff />,
    };
  },
});
